import {clientStaffRoutes} from '../utils';
import CreditCalculation from '../../views/creditcalculation/CreditCalculation.vue';

export default [
   ...clientStaffRoutes({
      name: 'credit-calculation',
      path: '/credit-calculation',
      component: CreditCalculation,
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {
            text: '__COMPANYNAME__',
            to: {name: 'company-detail', params: {id: 'FILL'}},
         },
         {text: 'Calculation'},
      ],
   }),
];
